import { capitalize } from 'lodash';
import dayjs from 'dayjs';
import i18n from 'i18n';
import { getDayjsLocale } from 'i18n/dateLocale';

const isDateToDisplayIsBefore = (stringDate: string, date: Date): string => {
  const stringDateDate = Number(stringDate.split('T')[0].split('-')[2]);
  if (date.getDate() < stringDateDate) {
    date.setDate(date.getDate() + 1);
  }

  const locale = getDayjsLocale(i18n.language);
  const displayDate = capitalize(dayjs(date).locale(locale).format('dddd D MMMM YYYY'));

  return displayDate;
};

export default isDateToDisplayIsBefore;
